import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'
import { useTranslation } from "react-i18next";

function Timeline() {
  const { t } = useTranslation();

  return (
    <div id="history">
      <div className="items-container">
        <h1>{t('timeline.title')}</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="Mar 2021 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase as any} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.positions.token.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a className="company-link" href="https://token.com" target="_blank" rel="noreferrer">
                {t('timeline.positions.token.company')}
              </a> - {t('timeline.positions.token.location')}
            </h4>
            <p>
              {t('timeline.positions.token.description')}
            </p>
            <ul className="task-list">
              {(() => {
                const tasks = t('timeline.positions.token.tasks', { returnObjects: true });
                return Array.isArray(tasks) ? tasks.map((task: any, index: number) => (
                  <li key={index}>{task}</li>
                )) : null;
              })()}
            </ul>
            <p>
              <strong>Stack:</strong> {t('timeline.positions.token.stack')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Mar 2021 - Aug 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase as any} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.positions.wellplayed.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a className="company-link" href="https://wellplayed.games/" target="_blank" rel="noreferrer">
                {t('timeline.positions.wellplayed.company')}
              </a> - {t('timeline.positions.wellplayed.location')}
            </h4>
            <p>
              {t('timeline.positions.wellplayed.description')}
            </p>
            <ul className="task-list">
              {(() => {
                const tasks = t('timeline.positions.wellplayed.tasks', { returnObjects: true });
                return Array.isArray(tasks) ? tasks.map((task: any, index: number) => (
                  <li key={index}>{task}</li>
                )) : null;
              })()}
            </ul>
            <p>
              <strong>Stack:</strong> {t('timeline.positions.wellplayed.stack')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Jan 2019 - Mar 2021"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase as any} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.positions.reby.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a className="company-link" href="https://www.linkedin.com/company/reby/" target="_blank" rel="noreferrer">
                {t('timeline.positions.reby.company')}
              </a> - {t('timeline.positions.reby.location')}
            </h4>
            <p>
              {t('timeline.positions.reby.description')}
            </p>
            <ul className="task-list">
              {(() => {
                const tasks = t('timeline.positions.reby.tasks', { returnObjects: true });
                return Array.isArray(tasks) ? tasks.map((task: any, index: number) => (
                  <li key={index}>{task}</li>
                )) : null;
              })()}
            </ul>
            <p>
              <strong>Firmware Stack:</strong> {t('timeline.positions.reby.firmwareStack')}<br />
              <strong>Backend Stack:</strong> {t('timeline.positions.reby.backendStack')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="Mar 2017 - Nov 2018"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase as any} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.positions.detnov.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a className="company-link" href="https://www.detnov.com/" target="_blank" rel="noreferrer">
                {t('timeline.positions.detnov.company')}
              </a> - {t('timeline.positions.detnov.location')}
            </h4>
            <p>
              {t('timeline.positions.detnov.description')}
            </p>
            <ul className="task-list">
              {(() => {
                const tasks = t('timeline.positions.detnov.tasks', { returnObjects: true });
                return Array.isArray(tasks) ? tasks.map((task: any, index: number) => (
                  <li key={index}>{task}</li>
                )) : null;
              })()}
            </ul>
            <p>
              <strong>Stack:</strong> {t('timeline.positions.detnov.stack')}
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="Nov 2011 - Mar 2017"
              iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
              icon={<FontAwesomeIcon icon={faBriefcase as any} />}
          >
            <h3 className="vertical-timeline-element-title">{t('timeline.positions.automatismos.title')}</h3>
            <h4 className="vertical-timeline-element-subtitle">
              <a className="company-link" href="https://www.automatismos.com/es" target="_blank" rel="noreferrer">
                {t('timeline.positions.automatismos.company')}
              </a> - {t('timeline.positions.automatismos.location')}
            </h4>
            <p>
              {t('timeline.positions.automatismos.description')}
            </p>
            <ul className="task-list">
              {(() => {
                const tasks = t('timeline.positions.automatismos.tasks', { returnObjects: true });
                return Array.isArray(tasks) ? tasks.map((task: any, index: number) => (
                  <li key={index}>{task}</li>
                )) : null;
              })()}
            </ul>
            <p>
              <strong>Stack:</strong> {t('timeline.positions.automatismos.stack')}
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;